import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent {

  @Input() message;
  @Input() modalType;
  @Input() fontSize = 'big';

  constructor(public activeModal: NgbActiveModal) { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/pop-up/pop-up.component.ts